// Stage types matching the backend stages table schema

export interface Stage {
  id: string;
  name: string;
  description?: string;
  category?: string; // e.g., 'fabrication', 'assembly', 'finishing'
  parent_stage_id?: string; // For hierarchical stages
  is_parallel: boolean; // Can work in parallel with other stages
  estimated_duration_minutes?: number; // Estimated time to complete
  required_skills?: string[]; // Array of skill IDs required
  status: 'active' | 'inactive';
  created_at: string;
  updated_at: string;
  
  // Additional computed properties for UI
  parent_stage?: Stage; // Populated parent stage object
  child_stages?: Stage[]; // Populated child stages
  skill_names?: string[]; // Human-readable skill names
}

export interface CreateStageRequest {
  name: string;
  description?: string;
  category?: string;
  parent_stage_id?: string;
  is_parallel?: boolean;
  estimated_duration_minutes?: number;
  skill_ids?: string[];
  status?: 'active' | 'inactive';
}

export interface UpdateStageRequest extends Partial<CreateStageRequest> {
  id: string;
}

export interface StageFilters {
  category?: string;
  status?: 'active' | 'inactive';
  parent_stage_id?: string | null;
  search?: string;
}

export interface StageFormData {
  name: string;
  description: string;
  category: string;
  parent_stage_id: string;
  is_parallel: boolean;
  estimated_duration_minutes: number;
  skill_ids: string[];
  status: 'active' | 'inactive';
}

// Default form data for new stages
export const defaultStageFormData: StageFormData = {
  name: '',
  description: '',
  category: '',
  parent_stage_id: '',
  is_parallel: false,
  estimated_duration_minutes: 0,
  skill_ids: [],
  status: 'active'
};

// Stage categories for dropdown
export const STAGE_CATEGORIES = [
  { value: 'fabrication', label: 'Fabrication' },
  { value: 'assembly', label: 'Assembly' },
  { value: 'finishing', label: 'Finishing' },
  { value: 'quality_control', label: 'Quality Control' },
  { value: 'packaging', label: 'Packaging' },
  { value: 'shipping', label: 'Shipping' },
  { value: 'other', label: 'Other' }
] as const;

// Status options
export const STAGE_STATUSES = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' }
] as const;
